// Login screen for Lumi. Single button → Emergent Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LumiLogin() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/lumi";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white px-6" data-testid="lumi-login">
      <div className="max-w-md w-full text-center">
        <div className="text-6xl mb-4">✨</div>
        <h1 className="text-4xl font-bold mb-2 tracking-tight">Lumi</h1>
        <p className="text-sm text-white/60 mb-10">Your Poodles &amp; Friends marketing assistant</p>
        <button
          onClick={handleLogin}
          data-testid="lumi-login-google"
          className="inline-flex items-center gap-3 bg-white text-black px-6 py-3 rounded-full text-sm font-medium hover:bg-white/90 transition-all"
        >
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 5c1.6 0 3 .55 4.13 1.45L19.42 3.5C17.45 1.7 14.86.5 12 .5 7.4.5 3.45 3.13 1.6 7.05l3.7 2.87C6.27 7 8.86 5 12 5z"/><path fill="#4285F4" d="M23.5 12.27c0-.79-.07-1.55-.2-2.27H12v4.51h6.47c-.28 1.5-1.13 2.78-2.4 3.62l3.7 2.86c2.16-2 3.43-4.93 3.43-8.72z"/><path fill="#FBBC05" d="M5.3 14.15a7.05 7.05 0 0 1 0-4.3l-3.7-2.87a11.5 11.5 0 0 0 0 10.04l3.7-2.87z"/><path fill="#34A853" d="M12 23.5c3.24 0 5.96-1.07 7.95-2.91l-3.7-2.86c-1.05.7-2.4 1.13-4.25 1.13-3.14 0-5.73-2-6.7-4.91l-3.7 2.87C3.45 20.87 7.4 23.5 12 23.5z"/></svg>
          Sign in with Google
        </button>
        <p className="text-xs text-white/40 mt-8">
          Internal tool. Only the Poodles &amp; Friends admin can access this app.
        </p>
      </div>
    </div>
  );
}
